<template>
  <main>
    <section class="mb-10 pb-10 px-10">
      <header class="container mx-auto mt-10 mb-8 grid grid-cols-6 gap-4">
        <h1 class="text-4xl col-start-1 col-end-5">
          <slot name="header-title"></slot>
        </h1>
        <div class="col-end-7 col-span-2 text-right">
          <slot name="header-actions"></slot>
        </div>
      </header>

      <slot name="subheader"/>

      <slot name="main"/>
    </section>
  </main>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'layout-main',

  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/components/layouts/main-layout.vue